import ChevronRight from '@material-ui/icons/ChevronRight';
import React from 'react';
import { H1, H3, Img } from '~frontend-common/components/ui';
import { useTranslator } from '~frontend-common/i18n/translator';
import { Box } from '~ui-kit/components/box';
import { styled } from '~ui-kit/styled-components';
import { Fab } from '../buttons';

export interface AppErrorProps {
  imageSrc: any;
  redirectionPath: string;
}

// Common component to display unknown errors
export function AppError({ imageSrc, redirectionPath }: AppErrorProps) {
  const { tl } = useTranslator();

  return (
    <PageWrapper
      flexDirection={['column', 'column', 'row', 'row']}
      height="100%"
      width="100%"
      px={[2, 3, 7]}
      pb={[4, 5, 7]}
      justifyContent="center"
      alignItems="center"
    >
      <Box justify={['center']}>
        <Logo
          mr={[0, 0, 7, 8]}
          height={['20em', '25em', '32em', '40em']}
          width={['12em', '15em', '20em', '25em']}
          src={imageSrc.error.unknown}
        />
      </Box>

      <Box alignItems={['center', 'center', 'baseline', 'baseline']} justifyContent="center" flexDirection="column">
        <H1 fontSize={[10]} fontWeight={400} mt={[5]} mb={[2]}>
          {tl('unknownError.headline')}
        </H1>
        <H3 fontSize={[6]} mb={[2]}>
          {tl('unknownError.title')}
        </H3>
        <H3 color="secondary" fontSize={[4]} mb={[5]}>
          {tl('unknownError.subtitle')}
        </H3>
        <Fab variant="extended" color="primary" size="large" type="link" href={redirectionPath}>
          {tl('buttons.home')}
          <ChevronRight />
        </Fab>
      </Box>
    </PageWrapper>
  );
}

const PageWrapper = styled(Box)`
  background-color: ${(props) => props.theme.colors.background};
  font-family: ${(props) => props.theme.fontFamily.montserrat};
`;

const Logo = styled(Img)`
  flex-grow: 1;
  position: relative;
`;
